import React from 'react';
import {Skeleton} from "@material-ui/lab";
import {Grid} from "@material-ui/core";

function MuiSkeleton({xs, number}) {
    return (
        <Grid container spacing={3}>
            {Array.from(Array(number), (e, i) => {
                return <Grid item xs={xs} key={i}>
                    <Skeleton variant="text" animation="wave" width={"100%"} />
                </Grid>
            })}
        </Grid>
    );
}

export default MuiSkeleton;